// 地址输入页面

<template>
  <div class="address">
    <div class="address-head">
      <div class="address-head-title">{{title}}</div>
      <img :src="headImage" alt="" class="address-head-img" />
    </div>
    <div class="address-desc">{{desc}}</div>
    <div class="address-form">
      <div class="address-form-item">
        <input type="text" class="address-input" placeholder="您的姓名" v-model="formData.name" />
      </div>
      <div class="address-form-item">
        <input type="phone" class="address-input" placeholder="您的电话" v-model="formData.phone" />
      </div>
      <div class="address-form-item">
        <input type="text" class="address-input" placeholder="您的详细地址" v-model="formData.address" />
      </div>
      <div class="address-form-submit">
        <UIButton
          width="420"
          height="90"
          fontSize="35"
          type="white"
          round
          inlineBlock
          :disabled="isSubmitted"
          @click="onSubmit"
        >
          {{isSubmitted ? '已提交' : '提交'}}
        </UIButton>
      </div>
    </div>
  </div>
</template>

<script>

import '@style/address.scss'
import headImage from '@/assets/images/address-head.png'
import UIButton from '@/components/UI/Button'
import api from '@edu-fe/api'
import login from '@edu-fe/login'

const request = {
  get: api.create('/activity/address/get'),
  post: api.create('/activity/address/save', {
    method: 'post'
  })
}

export default {
  data () {
    return {
      title: '',
      headImage,
      desc: '',
      isSubmitted: false,
      formData: {
        courseId: '',
        name: '',
        phone: '',
        address: ''
      }
    }
  },

  components: {
    UIButton
  },

  methods: {
    async onSubmit () {
      if (!this.formData.courseId) {
        return alert('请传入courseId!')
      }
      if (!this.formData.name) {
        return alert('请输入您的姓名!')
      }
      if (!this.formData.phone) {
        return alert('请输入您的电话号码!')
      }
      if (!/^1\d{10}$/.test(this.formData.phone)) {
        return alert('请输入正确的电话号码!')
      }
      if (!this.formData.address) {
        return alert('请输入您的详细地址!')
      }

      const { code } = await request.post(this.formData)

      if (code === 105) {
        alert('请勿重复提交!')
      } else if (code === 1026) {
        alert('该课程您尚未购买!')
      } else if (code === -2) {
        alert('请登录!')
      } else if (code === 1) {
        alert('提交成功!')
        this.isSubmitted = true
      } else {
        alert(`提交失败!(code: ${code})`)
      }
    }
  },

  async mounted() {
    const wpsSid = await login.getWpsSid()
    const {
      title = '地址输入页',
      desc = '请填写您的信息',
      courseId = ''
    } = this.$route.query

    if (!wpsSid) {
      const encode = str => window.encodeURIComponent(window.encodeURIComponent(str))
      const path = window.location.href.split('?')[0]
      const link = `${path}?title=${encode(title)}&desc=${encode(desc)}&courseId=${encode(courseId)}`
      login.login({ backUrl: link })
    }

    if (!courseId) {
      alert('请传入courseId!')
    } else {
      const { data } = await request.get({ courseId })
      if (data) {
        this.isSubmitted = true
        Object.assign(this.formData, data)
      }
    }

    this.title = title
    this.desc = desc
    this.formData.courseId = courseId
  }
}

</script>
